<template>
  <div class="content">
    <div class="box">
      <div class="title">
        <p v-for="item in [{ resourceName: '全部结果', resourceCode: '' }, ...tagList]" :key="item.resourceCode" @click="seachForTitle(item.resourceCode)" :style="params.resourceCode == item.resourceCode ? 'color: black' : 'color: #777;'">
          {{ item.resourceName }}
        </p>
      </div>
      <div class="li-box" v-for="item in list" :key="item.contentCode" @click="goDetail(item.contentId, item.contentType)">
        <div class="html-content design-html" v-html="returnTitle(item.contentTitle)"></div>
        <div>
          <span style="float: right">
            {{
                String(item.createTime).split(" ")[0]
            }}</span>
        </div>
      </div>
      <div style="text-align: center;margin: 20px 0;height: 30px;">
        <a-pagination showQuickJumper showSizeChanger :pageSizeOptions="pageSizeOptions" :pageSize="10" :total="total" :showTotal="total => `总共 ${total} 条`" :itemRender="itemRender" @change="onChange">
        </a-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getList,
  getResource
} from '@/api/search.js'
export default {
  name: 'middle-content',
  data () {
    return {
      pageSizeOptions: ['10', '20', '30'],
      total: 0,
      list: [],
      name: '',
      params: {
        resourceCode: ''
      },
      tagList: []
    }
  },
  created () {
    this.init()
    this._getResource()
  },
  watch: {
    $route: function (val, oldVal) {
      if (val.query.searchKey !== oldVal.query.searchKey) {
        this.init()
      }
    }
  },
  methods: {
    init () {
      this.name = this.$route.query.searchKey
      this.params = { inputText: this.name, resourceCode: '' }
      this._getList()
    },
    seachForTitle (code) {
      this.params.resourceCode = code
      this._getList()
    },
    _getResource () {
      getResource().then(res => {
        this.tagList = this._.get(res, 'data.records', []).reverse().filter(item => !['机构概况', '联系我们'].includes(item.resourceName))
      })
    },
    returnTitle (t) {
      return t.replace(/em/, `em style='color: #cbb486; padding: 0 3px;'`)
    },
    goDetail (contentCode, contentType) {
      const mapType = {
        'ANNOUNCE': 'contentAnnounce',
        'NEWS': '',
        'HELP': '',
      }
      const type = this.$route.query.type || ''
      const linkname = this.$route.query.linkname || ''
      this.pushRouter(`/guide?contentCode=${contentCode}&type=${mapType[contentType]}&linkname=${linkname}`)
    },
    _getList () {
      getList(this.params).then(res => {
        this.list = this._.get(res, 'data.list', [])
        this.total = this._.get(res, 'data.totalElements', 0)
      })
    },
    onChange (pageNumber) {
      this.params = JSON.parse(JSON.stringify({ ...this.params, pageNo: pageNumber }))
      this._getList()
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return <li class="ant-pagination-item"><a>上页</a></li>;
      } else if (type === 'next') {
        return <li class="ant-pagination-item"><a>下页</a></li>;
      }
      return originalElement;
    },
  }
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
}
.box {
  width: 1140px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
}
.title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 41px;
  text-align: left;
  margin-top: 30px;
  & > p {
    display: inline-block;
    padding-bottom: 5px;
    /* border-bottom:  2px solid #CBB486; */
    margin-bottom: 0;
    margin-right: 15px;
    cursor: pointer;
    color: #7f7f7f;
  }
}
.li-box {
  display: flex;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #eeeeee;
  cursor: pointer;
  & > div:nth-of-type(1) {
    /* flex: 1; */
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 80px;
    &:hover {
      color: #cbb486;
    }
  }
  & > div:nth-of-type(1)::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #cbb486;
    margin-right: 10px;
    transform: translateY(-2px);
  }
  & > div:nth-of-type(2) {
    flex: 100px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #bcbec0;
    text-align: right;
    line-height: 80px;
  }
}
/deep/ .ant-pagination-item-active {
  border: none;
  background: #cbb486;
}
/deep/ .ant-pagination-item-active a {
  color: white;
}
/deep/ .ant-pagination-item:hover {
  background: #cbb486;
  border: none;
  color: white;
}
/deep/ .ant-pagination-item:hover a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/search/siderContent-01.vue